import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const MODAL_OPEN_CLASS = 'body--modal-open';
const Modal = (props) => {
  useEffect(() => {
    document.body.classList.add(MODAL_OPEN_CLASS);

    return () => {
      document.body.classList.remove(MODAL_OPEN_CLASS);
    };
  }, []);

  const { className, children } = props;
  return (
    <div className={`modal ${className}`}>
      <div className="shroud" />
      <div className="card">
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Modal.defaultProps = {
  className: '',
  children: null,
};

export default Modal;
